export const PAGE_MARGIN_BOTTOM = 72;
